var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "bottom-info"
  }, [_c("div", [_c("span", [_vm._v("Copyright")]), _c("span", [_c("a", {
    attrs: {
      href: "https://www.fire2333.com"
    }
  }, [_vm._v("Xuangames")])])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };